import api from './api';

export interface EmailLog {
  id: number;
  to_email: string;
  cc_email: string | null;
  subject: string | null;
  body_html: string | null;
  body_text: string | null;
  template_name: string;
  mail_class: string | null;
  case_id: number | null;
  case_name: string | null;
  status: 'queued' | 'sent' | 'failed';
  error_message: string | null;
  sent_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface EmailLogPagination {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export interface EmailLogResponse {
  data: EmailLog[];
  pagination: EmailLogPagination;
}

export interface EmailLogDetailResponse {
  data: EmailLog;
}

export interface EmailLogFilters {
  page?: number;
  per_page?: number;
  status?: string;
  search?: string;
}

const TEMPLATE_LABELS: Record<string, string> = {
  case_approved: 'Case Approved',
  case_rejected: 'Case Rejected',
  case_created: 'Case Created',
  retainer_received: 'Retainer Received',
  slot_selection: 'Slot Selection',
  slot_booked: 'Slot Booked',
  teams_meeting_created: 'Teams Meeting Created',
  case_assigned_to_expert: 'Assigned to Expert',
  virtual_meeting_requested: 'Virtual Meeting Requested',
  in_person_requested: 'In-Person Meeting Requested',
  intake_form_submitted: 'Intake Form Submitted',
  intake_form_submitted_expert: 'Intake Form Submitted (Expert)',
  intake_form_links: 'Intake Form Links',
  medical_records_uploaded: 'Medical Records Uploaded',
  firm_registration_welcome: 'Firm Registration Welcome',
  admin_firm_registration: 'Admin Firm Registration',
  firm_approved: 'Firm Approved',
  firm_rejected: 'Firm Rejected',
  password_reset: 'Password Reset',
  new_user_welcome: 'New User Welcome',
};

export const getTemplateLabelName = (templateName: string): string =>
  TEMPLATE_LABELS[templateName] ??
  templateName
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const emailLogService = {
  async getEmailLogs(filters: EmailLogFilters = {}): Promise<EmailLogResponse> {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', String(filters.page));
    if (filters.per_page) params.append('per_page', String(filters.per_page));
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);

    const response = await api.get<EmailLogResponse>(`/email-logs?${params.toString()}`);
    return response.data;
  },

  async getEmailLog(id: number): Promise<EmailLogDetailResponse> {
    const response = await api.get<EmailLogDetailResponse>(`/email-logs/${id}`);
    return response.data;
  },
};
